<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button
        previousPageTitle="{{ 'INBOX.SETTINGS.INBOX_SETTINGS' | translate }}"
        previousPageUrl="{{ previousPageRoute$ | async }}"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>{{ 'INBOX.SETTINGS.SMS_REGISTRATION' | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper>
    <sms-registration></sms-registration>
  </glxy-page-wrapper>
</glxy-page>
